<p-confirmDialog key="main" [style]="{ width: '400px' }" [baseZIndex]="10000"></p-confirmDialog>
<p-confirmDialog key="confirmdelete" [style]="{ width: '400px' }" [baseZIndex]="10000"></p-confirmDialog>

<div class="row">
	<div class="col-lg-12">
		<div class="ibox float-e-margins">
			<div class="ibox-content">
				<!--Menu Bar-->
				<div class="lock-to-top" style="background-color: #ffffff">
					<!--Buttons-->
					<div class="button-body flex">
						<button [disabled]="IsLoading() == true" class="btn btn-primary" style="margin-left: 0px" (click)="onRefresh()">Refresh</button>

						<!--INSERT CUSTOM BUTTONS HERE-->
						<button [disabled]="IsLoading() == true" class="btn btn-primary" style="margin-left: 5px" (click)="onAdd()">Add Alert Type</button>
						<button [disabled]="IsLoading() == true || CanEdit() == false" class="btn btn-primary" style="margin-left: 5px" (click)="onEdit()">
							Edit Alert Type
						</button>
						<button [disabled]="IsLoading() == true || CanEdit() == false" class="btn btn-primary" style="margin-left: 5px" (click)="onToggle()">
							{{ ToggleText }}
						</button>
						<button [disabled]="IsLoading() == true || CanEdit() == false" class="btn btn-primary" style="margin-left: 5px" (click)="onDelete()">
							Delete Alert Type
						</button>
					</div>
				</div>

				<!--Table-->
				<div class="table-main-body">
					<p-table
						#mydt
						[value]="lstAlertType"
						[loading]="loading"
						[paginator]="true"
						[(rows)]="pagerows"
						[(first)]="pagefirst"
						[showCurrentPageReport]="true"
						[resizableColumns]="false"
						sortMode="multiple"
						styleClass="p-datatable-striped"
						selectionMode="single"
						[(selection)]="SelectedAlertType"
						dataKey="AlertTypeID"
						(onFilter)="onHandleFilter($event)"
						(onSort)="onHandleSort($event)"
						(onRowSelect)="onRowSelect($event)"
						(onRowUnselect)="onRowUnselect($event)"
						currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
						[rowsPerPageOptions]="[5, 10, 25, 50]"
					>
						<!--Headers-->
						<ng-template pTemplate="header">
							<!--Filter or Select from Dropdown-->
							<tr>
								<!--INSERT CUSTOM FILTERS HERE-->

								<!--AlertTypeCD-->
								<th>
									<p-columnFilter type="text" field="AlertTypeCD" matchMode="contains" [showMenu]="true"></p-columnFilter>
								</th>

								<!--AlertTypeDesc-->
								<th>
									<p-columnFilter type="text" field="AlertTypeDesc" matchMode="contains" [showMenu]="true"></p-columnFilter>
								</th>

								<!--Severity-->
								<th>
									<p-columnFilter field="SeverityDesc" matchMode="equals" [showMenu]="false">
										<ng-template pTemplate="filter" let-value let-filter="filterCallback">
											<p-dropdown
												#filterSeverityDesc
												[ngModel]="value"
												[options]="lstSeverityDesc"
												(onChange)="filter($event.value)"
												placeholder="Any"
												[showClear]="true"
											>
												<ng-template let-value pTemplate="item">
													<span>{{ value }}</span>
												</ng-template>
											</p-dropdown>
										</ng-template>
									</p-columnFilter>
								</th>

								<!--DefinedByDesc-->
								<th>
									<p-columnFilter field="DefinedByDesc" matchMode="equals" [showMenu]="false">
										<ng-template pTemplate="filter" let-value let-filter="filterCallback">
											<p-dropdown
												#filterDefinedByDesc
												[ngModel]="value"
												[options]="lstDefinedByDesc"
												(onChange)="filter($event.value)"
												placeholder="Any"
												[showClear]="true"
											>
												<ng-template let-value pTemplate="item">
													<span>{{ value }}</span>
												</ng-template>
											</p-dropdown>
										</ng-template>
									</p-columnFilter>
								</th>

								<!--ActiveDesc-->
								<th>
									<p-columnFilter field="ActiveDesc" matchMode="equals" [showMenu]="false">
										<ng-template pTemplate="filter" let-value let-filter="filterCallback">
											<p-dropdown
												#filterActiveDesc
												[ngModel]="value"
												[options]="lstActiveDesc"
												(onChange)="filter($event.value)"
												placeholder="Any"
												[showClear]="true"
											>
												<ng-template let-value pTemplate="item">
													<span>{{ value }}</span>
												</ng-template>
											</p-dropdown>
										</ng-template>
									</p-columnFilter>
								</th>
							</tr>

							<!--Column Names-->
							<tr style="height: 4rem">
								<!--INSERT CUSTOM COLUMNS HERE-->
								<th pSortableColumn="AlertTypeCD">Code<p-sortIcon field="AlertTypeCD"></p-sortIcon></th>
								<th pSortableColumn="AlertTypeDesc">Description<p-sortIcon field="AlertTypeDesc"></p-sortIcon></th>
								<th pSortableColumn="Severity">Severity<p-sortIcon field="Severity"></p-sortIcon></th>
								<th pSortableColumn="DefinedByID">Defined By<p-sortIcon field="DefinedByID"></p-sortIcon></th>
								<th pSortableColumn="ActiveDesc">Active<p-sortIcon field="ActiveDesc"></p-sortIcon></th>
							</tr>
						</ng-template>

						<!--Data-->
						<ng-template pTemplate="body" let-AlertType>
							<tr [pSelectableRow]="AlertType" (dblclick)="onRowDblClick(AlertType)">
								<td *ngFor="let col of cols" style="font-weight: bold; text-overflow: ellipsis; word-break: break-word">
									{{ AlertType[col.field] }}
								</td>

								<td
									style="font-weight: bold; text-overflow: ellipsis; word-break: break-word"
									[style.color]="AlertType.DefinedByID > 2 ? 'Black' : 'Red'"
								>
									{{ AlertType["DefinedByDesc"] }}
								</td>

								<td
									style="font-weight: bold; text-overflow: ellipsis; word-break: break-word"
									[style.color]="AlertType.Active == true ? 'Black' : 'Red'"
								>
									{{ AlertType["ActiveDesc"] }}
								</td>
							</tr>
						</ng-template>
					</p-table>
				</div>

				<!--Error Message-->
				<div class="TopMargin">
					<div name="errorMessage" *ngIf="errorMessage" class="alert alert-danger">
						{{ errorMessage }}
					</div>
				</div>
			</div>
		</div>
	</div>
</div>
